import * as insurancesApi from '../../api/insuranceListApi';

const GET_DRAFT_TRAVEL_INSURANCE_LIST = 'efes/insurances/GET_DRAFT_TRAVEL_INSURANCE_LIST';
const GET_DRAFT_TRAVEL_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_DRAFT_TRAVEL_INSURANCE_LIST_SUCCESS';
const GET_DRAFT_TRAVEL_INSURANCE_LIST_FAIL = 'efes/insurances/GET_DRAFT_TRAVEL_INSURANCE_LIST_FAIL';

const GET_TRAVEL_INSURANCE_LIST = 'efes/insurances/GET_TRAVEL_INSURANCE_LIST';
const GET_TRAVEL_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_TRAVEL_INSURANCE_LIST_SUCCESS';
const GET_TRAVEL_INSURANCE_LIST_FAIL = 'efes/insurances/GET_TRAVEL_INSURANCE_LIST_FAIL';

const GET_DRAFT_PROPERTY_INSURANCE_LIST = 'efes/insurances/GET_DRAFT_PROPERTY_INSURANCE_LIST';
const GET_DRAFT_PROPERTY_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_DRAFT_PROPERTY_INSURANCE_LIST_SUCCESS';
const GET_DRAFT_PROPERTY_INSURANCE_LIST_FAIL = 'efes/insurances/GET_DRAFT_PROPERTY_INSURANCE_LIST_FAIL';

const GET_PROPERTY_INSURANCE_LIST = 'efes/insurances/GET_PROPERTY_INSURANCE_LIST';
const GET_PROPERTY_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_PROPERTY_INSURANCE_LIST_SUCCESS';
const GET_PROPERTY_INSURANCE_LIST_FAIL = 'efes/insurances/GET_PROPERTY_INSURANCE_LIST_FAIL';

const GET_CMTPL_INSURANCE_LIST = 'efes/insurances/GET_CMTPL_INSURANCE_LIST';
const GET_CMTPL_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_CMTPL_INSURANCE_LIST_SUCCESS';
const GET_CMTPL_INSURANCE_LIST_FAIL = 'efes/insurances/GET_CMTPL_INSURANCE_LIST_FAIL';

const GET_CMTPL_CASCO_INSURANCE_LIST = 'efes/insurances/GET_CMTPL_CASCO_INSURANCE_LIST';
const GET_CMTPL_CASCO_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_CMTPL_CASCO_INSURANCE_LIST_SUCCESS';
const GET_CMTPL_CASCO_INSURANCE_LIST_FAIL = 'efes/insurances/GET_CMTPL_CASCO_INSURANCE_LIST_FAIL';

const GET_VMTPL_INSURANCE_LIST = 'efes/insurances/GET_VMTPL_INSURANCE_LIST';
const GET_VMTPL_INSURANCE_LIST_SUCCESS = 'efes/insurances/GET_VMTPL_INSURANCE_LIST_SUCCESS';
const GET_VMTPL_INSURANCE_LIST_FAIL = 'efes/insurances/GET_VMTPL_INSURANCE_LIST_FAIL';

const initialState = {
  draftTravelInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  travelInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  draftPropertyInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  propertyInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  cmtplInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  cmtplCascoInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
  vmtplInsuranceList: {
    tblData: { data: [], total: 0 },
    isLoading: true,
    error: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_DRAFT_PROPERTY_INSURANCE_LIST:
      return {
        ...state,
        draftPropertyInsuranceList: {
          ...state.draftPropertyInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_DRAFT_PROPERTY_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        draftPropertyInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_DRAFT_PROPERTY_INSURANCE_LIST_FAIL:
      return {
        ...state,
        draftPropertyInsuranceList: {
          ...state.draftPropertyInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_PROPERTY_INSURANCE_LIST:
      return {
        ...state,
        propertyInsuranceList: {
          ...state.propertyInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_PROPERTY_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        propertyInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_PROPERTY_INSURANCE_LIST_FAIL:
      return {
        ...state,
        propertyInsuranceList: {
          ...state.propertyInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_DRAFT_TRAVEL_INSURANCE_LIST:
      return {
        ...state,
        draftTravelInsuranceList: {
          ...state.draftTravelInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_DRAFT_TRAVEL_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        draftTravelInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_DRAFT_TRAVEL_INSURANCE_LIST_FAIL:
      return {
        ...state,
        draftTravelInsuranceList: {
          ...state.draftTravelInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_TRAVEL_INSURANCE_LIST:
      return {
        ...state,
        travelInsuranceList: {
          ...state.travelInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_TRAVEL_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        travelInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_TRAVEL_INSURANCE_LIST_FAIL:
      return {
        ...state,
        travelInsuranceList: {
          ...state.travelInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_CMTPL_INSURANCE_LIST:
      return {
        ...state,
        cmtplInsuranceList: {
          ...state.cmtplInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_CMTPL_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        cmtplInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_CMTPL_INSURANCE_LIST_FAIL:
      return {
        ...state,
        cmtplInsuranceList: {
          ...state.cmtplInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_CMTPL_CASCO_INSURANCE_LIST:
      return {
        ...state,
        cmtplCascoInsuranceList: {
          ...state.cmtplCascoInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_CMTPL_CASCO_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        cmtplCascoInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_CMTPL_CASCO_INSURANCE_LIST_FAIL:
      return {
        ...state,
        cmtplCascoInsuranceList: {
          ...state.cmtplCascoInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_VMTPL_INSURANCE_LIST:
      return {
        ...state,
        vmtplInsuranceList: {
          ...state.vmtplInsuranceList,
          isLoading: true,
          error: null,
        },
      };
    case GET_VMTPL_INSURANCE_LIST_SUCCESS:
      return {
        ...state,
        vmtplInsuranceList: {
          tblData: action.result,
          isLoading: false,
          error: null,
        },
      };
    case GET_VMTPL_INSURANCE_LIST_FAIL:
      return {
        ...state,
        vmtplInsuranceList: {
          ...state.vmtplInsuranceList,
          isLoading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}

export function getDraftPropertyInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_DRAFT_PROPERTY_INSURANCE_LIST },
      { type: GET_DRAFT_PROPERTY_INSURANCE_LIST_SUCCESS },
      {
        type: GET_DRAFT_PROPERTY_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchDraftPropertyInsuranceList(userId, params, filters),
  };
}
export function getPropertyInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_PROPERTY_INSURANCE_LIST },
      { type: GET_PROPERTY_INSURANCE_LIST_SUCCESS },
      {
        type: GET_PROPERTY_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchPropertyInsuranceList(userId, params, filters),
  };
}

export function getDraftTravelInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_DRAFT_TRAVEL_INSURANCE_LIST },
      { type: GET_DRAFT_TRAVEL_INSURANCE_LIST_SUCCESS },
      {
        type: GET_DRAFT_TRAVEL_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchDraftTravelInsuranceList(userId, params, filters),
  };
}
export function getTravelInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_TRAVEL_INSURANCE_LIST },
      { type: GET_TRAVEL_INSURANCE_LIST_SUCCESS },
      {
        type: GET_TRAVEL_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchTravelInsuranceList(userId, params, filters),
  };
}

export function getCMTPLInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_CMTPL_INSURANCE_LIST },
      { type: GET_CMTPL_INSURANCE_LIST_SUCCESS },
      {
        type: GET_CMTPL_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchCMTPLInsuranceList(userId, params, filters),
  };
}

export function getCMTPLCascoInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_CMTPL_CASCO_INSURANCE_LIST },
      { type: GET_CMTPL_CASCO_INSURANCE_LIST_SUCCESS },
      {
        type: GET_CMTPL_CASCO_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchCMTPLCascoInsuranceList(userId, params, filters),
  };
}

export function getVMTPLInsuranceList({ userId, params, filters }) {
  return {
    actions: [
      { type: GET_VMTPL_INSURANCE_LIST },
      { type: GET_VMTPL_INSURANCE_LIST_SUCCESS },
      {
        type: GET_VMTPL_INSURANCE_LIST_FAIL,
        showError: true,
      },
    ],
    promise: insurancesApi.fetchVMTPLInsuranceList(userId, params, filters),
  };
}
